import { Badge } from "react-bootstrap";
import rawTaskStatuses from "./taskStatuses";

const COLORS = {
  neutral: { background: "#EEF0F0", color: "#5A6163" },
  inProgress: { background: "#D9E5E2", color: "#2F4F4A" },
  waitingInternal: { background: "#FBEBD3", color: "#7A4E0E" },
  waitingExternal: { background: "#F8E1DF", color: "#8A2F29" },
};

const colorsFor = (value) => {
  if (value === "BLOCKED") return COLORS.waitingExternal;
  if (value === "BLOCKED_INTERNALLY" || value === "BLOCKED_INTERNALLY_PROVIDER" || value === "BLOCKED_SUBMITTED") return COLORS.waitingInternal;
  if (value === "IN_PROGRESS") return COLORS.inProgress;
  return COLORS.neutral;
};

const TaskStatusBadge = ({ status, className = "", onlyShowWhenBlocked = false, showDot = false }) => {
  const match = rawTaskStatuses.find((s) => s.value === status || s.label === status);

  if (!match || !match.shortLabel) {
    return null;
  }

  const isBlocked = match.value === "BLOCKED" || match.value === "BLOCKED_INTERNALLY" || match.value === "BLOCKED_INTERNALLY_PROVIDER" || match.value === "BLOCKED_SUBMITTED";

  if (onlyShowWhenBlocked && !isBlocked) {
    return null;
  }

  return (
    <Badge pill className={className} bg="" title={match.label} style={{ ...colorsFor(match.value), fontWeight: 500 }}>
      {showDot && <span style={{ display: "inline-block", width: "7px", height: "7px", borderRadius: "50%", backgroundColor: "currentColor", marginRight: "5px", verticalAlign: "middle" }} />}
      {match.shortLabel}
    </Badge>
  );
};

export default TaskStatusBadge;
